import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Badge,
} from "react-bootstrap";
import "../../assets/css/donordashboard/DonateRequest.css";
import MasterLayout from "../../components/layout/MasterLayout";
const DonateRequest = () => {
  // State Management
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeStatus, setActiveStatus] = useState("Requested");
  const [locationSearch, setLocationSearch] = useState("");
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  // Modal Form State
  const [acceptanceData, setAcceptanceData] = useState({
    date: "",
    time: "",
    pickupLocation: "",
  });

  // Mock Data - Requests from Receivers
  const allRequests = [
    {
      id: "REQ001",
      receiverId: "RCV-12345",
      title: "Urgent Food Required for Family",
      category: "Food",
      quantity: "5 kg Rice + Dal",
      description:
        "Need food supplies for a family of 5. Any help appreciated.",
      location: "Johar Town, Gujranwala",
      status: "Requested",
      urgency: "High",
      postedDate: "2024-03-10",
    },
    // {
    //   id: "REQ002",
    //   receiverId: "RCV-67890",
    //   title: "Blood Donation Required - O+",
    //   category: "Blood",
    //   quantity: "2 Units",
    //   description: "Emergency blood needed for surgery at Mayo Hospital.",
    //   location: "Mayo Hospital, Lahore",
    //   status: "Requested",
    //   urgency: "Critical",
    //   postedDate: "2024-03-11",
    // },
    // {
    //   id: "REQ003",
    //   receiverId: "RCV-24680",
    //   title: "Medicines for Diabetes Patient",
    //   category: "Medicine",
    //   quantity: "1 Month Supply",
    //   description: "Need diabetes medication including insulin and glucometer strips.",
    //   location: "Model Town, Lahore",
    //   status: "Requested",
    //   urgency: "Medium",
    //   postedDate: "2024-03-09",
    // },
    // {
    //   id: "REQ004",
    //   receiverId: "RCV-13579",
    //   title: "Shelter Space for Homeless",
    //   category: "Property",
    //   quantity: "1 Room",
    //   description: "Looking for temporary shelter for elderly couple.",
    //   location: "Gulberg, Lahore",
    //   status: "Requested",
    //   urgency: "High",
    //   postedDate: "2024-03-10",
    // },
    // {
    //   id: "REQ005",
    //   receiverId: "RCV-98765",
    //   title: "Food Packages for Orphanage",
    //   category: "Food",
    //   quantity: "20 Packages",
    //   description: "Monthly food supplies needed for orphanage children.",
    //   location: "Cantt, Lahore",
    //   status: "Requested",
    //   urgency: "Medium",
    //   postedDate: "2024-03-08",
    // },
    // {
    //   id: "REQ006",
    //   receiverId: "RCV-11223",
    //   title: "AB+ Blood Needed",
    //   category: "Blood",
    //   quantity: "3 Units",
    //   description: "Blood needed for accident victim at General Hospital.",
    //   location: "General Hospital, Lahore",
    //   status: "Requested",
    //   urgency: "Critical",
    //   postedDate: "2024-03-11",
    // },
    // {
    //   id: "REQ007",
    //   receiverId: "RCV-44556",
    //   title: "Heart Medication Required",
    //   category: "Medicine",
    //   quantity: "15 Days Supply",
    //   description: "Urgent heart medication needed for cardiac patient.",
    //   location: "DHA, Lahore",
    //   status: "Requested",
    //   urgency: "High",
    //   postedDate: "2024-03-10",
    // },
  ];

  // Categories with Icons
  const categories = [
    { name: "Food", icon: "🍲", color: "#14B8A6" },
    { name: "Medicine", icon: "💊", color: "#14B8A6" },
    { name: "Blood", icon: "🩸", color: "#14B8A6" },
  ];

  // Status Options
  const statusOptions = ["Requested", "Accepted", "Completed"];

  // Filter Logic
  useEffect(() => {
    let filtered = allRequests;

    // Category Filter
    if (activeCategory !== "All") {
      filtered = filtered.filter((req) => req.category === activeCategory);
    }

    // Status Filter
    filtered = filtered.filter((req) => req.status === activeStatus);

    // Location Search
    if (locationSearch.trim() !== "") {
      filtered = filtered.filter((req) =>
        req.location.toLowerCase().includes(locationSearch.toLowerCase()),
      );
    }

    setFilteredRequests(filtered);
  }, [activeCategory, activeStatus, locationSearch]);

  // Get Category Icon
  const getCategoryIcon = (category) => {
    const cat = categories.find((c) => c.name === category);
    return cat ? cat.icon : "📦";
  };

  // Get Urgency Badge
  const getUrgencyBadge = (urgency) => {
    const colors = {
      Critical: "danger",
      High: "warning",
      Medium: "info",
      Low: "secondary",
    };
    return colors[urgency] || "secondary";
  };

  // Handle Accept Request
  const handleAcceptRequest = (request) => {
    setSelectedRequest(request);
    setShowModal(true);
  };

  // Handle Modal Close
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRequest(null);
    setAcceptanceData({ date: "", time: "", pickupLocation: "" });
  };

  // Handle Confirm Acceptance
  const handleConfirmAcceptance = () => {
    if (
      !acceptanceData.date ||
      !acceptanceData.time ||
      !acceptanceData.pickupLocation
    ) {
      alert("Please fill all fields!");
      return;
    }

    // Update request status (in real app, this would be an API call)
    console.log("Accepting Request:", {
      requestId: selectedRequest.id,
      ...acceptanceData,
    });

    alert(
      `Request ${selectedRequest.id} accepted successfully!\n\nPickup Details:\nDate: ${acceptanceData.date}\nTime: ${acceptanceData.time}\nLocation: ${acceptanceData.pickupLocation}`,
    );

    handleCloseModal();
  };

  // Handle Input Change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAcceptanceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="ddr-page">
      <MasterLayout>
        {/* Hero Section */}
        <div className="ddr-hero">
          <Container>
            <div className="ddr-hero-content">
              <h1 className="ddr-hero-title">
                Discover Requests
                <span className="ddr-title-accent"> & Make a Difference</span>
              </h1>
              <p className="ddr-hero-subtitle">
                Browse urgent requests from those in need and become someone's
                hero today
              </p>
            </div>
          </Container>
        </div>

        {/* Filter Section */}
        <div className="ddr-filter-section">
          <Container>
            <div className="ddr-filter-container">
              {/* Category Filters */}
              <div className="ddr-category-filters">
                <label className="ddr-filter-label">Categories:</label>
                <div className="ddr-filter-buttons">
                  {categories.map((category) => (
                    <button
                      key={category.name}
                      className={`ddr-filter-btn ${
                        activeCategory === category.name ? "ddr-active" : ""
                      }`}
                      onClick={() => setActiveCategory(category.name)}
                    >
                      <span className="ddr-filter-icon">{category.icon}</span>
                      <span className="ddr-filter-text">{category.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Results Count */}
            <div className="ddr-results-info">
              <p className="ddr-results-count">
                Showing <strong>{filteredRequests.length}</strong> requests
              </p>
            </div>
          </Container>
        </div>

        {/* Request Cards Grid */}
        <div className="ddr-cards-section">
          <Container>
            {filteredRequests.length === 0 ? (
              <div className="ddr-no-results">
                <div className="ddr-no-results-icon">🔍</div>
                <h3>No Requests Found</h3>
                <p>Try adjusting your filters to see more results</p>
              </div>
            ) : (
              <Row className="g-4">
                {filteredRequests.map((request, index) => (
                  <Col key={request.id} lg={4} md={6} sm={12}>
                    <div
                      className="ddr-request-card"
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      {/* Card Header */}
                      <div className="ddr-card-header">
                        <div className="ddr-category-badge">
                          <span className="ddr-category-icon">
                            {getCategoryIcon(request.category)}
                          </span>
                          <span className="ddr-category-name">
                            {request.category}
                          </span>
                        </div>
                        <Badge
                          bg={getUrgencyBadge(request.urgency)}
                          className="ddr-urgency-badge"
                        >
                          {request.urgency}
                        </Badge>
                      </div>

                      {/* Card Body */}
                      <div className="ddr-card-body">
                        <h3 className="ddr-request-title">{request.title}</h3>

                        <div className="ddr-request-meta">
                          <div className="ddr-meta-item">
                            <span className="ddr-meta-label">Qty:</span>
                            <span className="ddr-meta-value">
                              {request.quantity}
                            </span>
                          </div>
                          <div className="ddr-meta-item">
                            <span className="ddr-meta-label">ID:</span>
                            <span className="ddr-meta-value">
                              {request.receiverId}
                            </span>
                          </div>
                        </div>

                        <p className="ddr-request-description">
                          {request.description}
                        </p>

                        <div className="ddr-request-location">
                          <span className="ddr-location-icon">📍</span>
                          <span className="ddr-location-text">
                            {request.location}
                          </span>
                        </div>

                        <div className="ddr-request-date">
                          <span className="ddr-date-icon">📅</span>
                          <span className="ddr-date-text">
                            Posted: {request.postedDate}
                          </span>
                        </div>
                      </div>

                      {/* Card Footer */}
                      <div className="ddr-card-footer">
                        <button
                          className="ddr-help-button"
                          onClick={() => handleAcceptRequest(request)}
                        >
                          <span className="ddr-button-icon">🤝</span>
                          <span className="ddr-button-text">Help Now</span>
                        </button>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </Container>
        </div>

        {/* Acceptance Modal */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          className="ddr-modal"
          size="lg"
        >
          <Modal.Header closeButton className="ddr-modal-header">
            <Modal.Title className="ddr-modal-title">
              <span className="ddr-modal-icon">🤝</span>
              Accept Request
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="ddr-modal-body">
            {selectedRequest && (
              <>
                {/* Request Summary */}
                <div className="ddr-request-summary">
                  <h4 className="ddr-summary-title">Request Details</h4>
                  <div className="ddr-summary-content">
                    <div className="ddr-summary-row">
                      <span className="ddr-summary-label">Title:</span>
                      <span className="ddr-summary-value">
                        {selectedRequest.title}
                      </span>
                    </div>
                    <div className="ddr-summary-row">
                      <span className="ddr-summary-label">Category:</span>
                      <span className="ddr-summary-value">
                        {getCategoryIcon(selectedRequest.category)}{" "}
                        {selectedRequest.category}
                      </span>
                    </div>
                    <div className="ddr-summary-row">
                      <span className="ddr-summary-label">Quantity:</span>
                      <span className="ddr-summary-value">
                        {selectedRequest.quantity}
                      </span>
                    </div>
                    <div className="ddr-summary-row">
                      <span className="ddr-summary-label">
                        Drop-off Location:
                      </span>
                      <span className="ddr-summary-value">
                        {selectedRequest.location}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Pickup Details Form */}
                <div className="ddr-pickup-form">
                  <h4 className="ddr-form-title">Pickup Details</h4>
                  <Form>
                    {/* Date Picker */}
                    <Form.Group className="mb-3">
                      <Form.Label className="ddr-form-label">
                        <span className="ddr-label-icon">📅</span>
                        Pickup Date
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="date"
                        value={acceptanceData.date}
                        onChange={handleInputChange}
                        className="ddr-form-control"
                        required
                      />
                    </Form.Group>

                    {/* Time Picker */}
                    <Form.Group className="mb-3">
                      <Form.Label className="ddr-form-label">
                        <span className="ddr-label-icon">⏰</span>
                        Pickup Time
                      </Form.Label>
                      <Form.Control
                        type="time"
                        name="time"
                        value={acceptanceData.time}
                        onChange={handleInputChange}
                        className="ddr-form-control"
                        required
                      />
                    </Form.Group>

                    {/* Pickup Location */}
                    <Form.Group className="mb-3">
                      <Form.Label className="ddr-form-label">
                        <span className="ddr-label-icon">📍</span>
                        Your Pickup Location
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="pickupLocation"
                        value={acceptanceData.pickupLocation}
                        onChange={handleInputChange}
                        placeholder="Enter your complete address for pickup..."
                        className="ddr-form-control"
                        required
                      />
                      <Form.Text className="text-muted">
                        Please provide your complete address where we can pick
                        up the donation.
                      </Form.Text>
                    </Form.Group>
                  </Form>
                </div>
              </>
            )}
          </Modal.Body>

          <Modal.Footer className="ddr-modal-footer">
            <button className="ddr-cancel-button" onClick={handleCloseModal}>
              Cancel
            </button>
            <button
              className="ddr-confirm-button"
              onClick={handleConfirmAcceptance}
            >
              <span className="ddr-button-icon">✅</span>
              <span className="ddr-button-text">Confirm & Accept</span>
            </button>
          </Modal.Footer>
        </Modal>
      </MasterLayout>
    </div>
  );
};

export default DonateRequest;
